import React from 'react';
import PropTypes from 'prop-types';
import ResultTableTab from 'components/admin/result/ResultTableTab';
import AdminDataTable from 'components/admin/AdminDataTable';
import { ageViewTrackEventColumns } from 'config/admin/result';

const AgeViewTrackResultDataTable = ({
  dataTypeOptions = [],
  optionValues,
  handleOptionChange,
  results,
}) => {
  return results.length ? (
    <>
      <ResultTableTab
        dataTypeOptions={dataTypeOptions}
        optionValues={optionValues}
        handleOptionChange={handleOptionChange}
      />
      <AdminDataTable
        borderType="full"
        isAddedFeatures={false}
        columns={ageViewTrackEventColumns}
        data={results}
        searchInputPlaceholder=""
        headStyle={{
          gridTemplateColumns: '2fr 4fr 3fr 3fr 3fr 3fr 3fr 3fr 2fr',
          background: '#f1f1f2',
        }}
        rowStyle={{
          gridTemplateColumns: '2fr 4fr 3fr 3fr 3fr 3fr 3fr 3fr 2fr',
        }}
      />
    </>
  ) : null;
};

AgeViewTrackResultDataTable.propTypes = {
  dataTypeOptions: PropTypes.arrayOf(PropTypes.object),
  optionValues: PropTypes.object,
  handleOptionChange: PropTypes.func,
  results: PropTypes.array.isRequired,
};
export default AgeViewTrackResultDataTable;
